module.exports = __webpack_public_path__ + "img/milkHouses.0a41f311.svg";